angular.module('mw-alert', ['mw-alert-template']);